import { defineComponent, onMounted, ref } from '@vue/composition-api';
import SpinnerLoader from '@/components/ui/loader/SpinnerLoader.vue';
const PrivacyPolicyComponent = () => ({
    component: import('./PrivacyPolicy.ts.vue'),
    loading: SpinnerLoader,
    delay: 0,
});
// Can increment this to force the policy to be shown again in the case of a changed policy
const LOCAL_STORAGE_KEY = 'dp.priavcy-policy-accepted.v1';
export default defineComponent({
    name: 'PrivacyPolicyOverlay',
    components: {
        PrivacyPolicyComponent,
    },
    setup() {
        const isOpen = ref(true);
        const accepted = ref(false);
        const loading = ref(false);
        const { localStorage } = window;
        const acceptPolicy = () => {
            loading.value = true;
            localStorage.setItem(LOCAL_STORAGE_KEY, '1');
            // Make it look like something actually happens when clicking the button, because it feels
            // weird without it. This can be replaced with some sort of call to save data in the future
            setTimeout(() => {
                loading.value = false;
                isOpen.value = false;
            }, 100);
        };
        onMounted(() => {
            const previous = localStorage.getItem(LOCAL_STORAGE_KEY);
            if (previous === '1') {
                isOpen.value = false;
            }
        });
        return {
            isOpen,
            accepted,
            loading,
            acceptPolicy,
        };
    },
});
